import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Conocer la verguenza",
    opening: localizedGenderNode(
      [
      "Hoy no me empujo a hablar.",
      "Solo noto: hay verguenza en mi frente a un grupo.",
      "Una respiracion."
    ],
      [
      "Hoy no me empujo a hablar.",
      "Solo noto: hay verguenza en mi frente a un grupo.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa en mi cuando pienso en hablar frente a otros?",
      "Que temo que vean en mi?",
      "Que necesito escuchar de mi ahora?"
    ],
      [
      "Que pasa en mi cuando pienso en hablar frente a otros?",
      "Que temo que vean en mi?",
      "Que necesito escuchar de mi ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando lo nombro, se siente menos abrumador."
    ],
      [
      "Cuando lo nombro, se siente menos abrumador."
    ]
    ),
    action: localizedGenderNode(
      "me digo en silencio \"estoy conmigo\".",
      "me digo en silencio \"estoy conmigo\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el primer momento antes de tener que hablar.",
      "No avanzo. Solo noto.",
      "Una respiracion."
    ],
      [
      "Hoy noto el primer momento antes de tener que hablar.",
      "No avanzo. Solo noto.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando es más fuerte? (antes / durante la reunion)",
      "Que es lo primero que siento en el cuerpo?",
      "Que es lo primero que salta en mi mente?"
    ],
      [
      "Cuando es más fuerte? (antes / durante la reunion)",
      "Que es lo primero que siento en el cuerpo?",
      "Que es lo primero que salta en mi mente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El primer momento es una pequeña grieta de eleccion."
    ],
      [
      "El primer momento es una pequeña grieta de eleccion."
    ]
    ),
    action: localizedGenderNode(
      "cuando sube, hago una pausa de dos respiraciones.",
      "cuando sube, hago una pausa de dos respiraciones."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Mi cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy le doy a mi cuerpo una palabra.",
      "Sin juicio. Solo descripcion.",
      "Una respiracion."
    ],
      [
      "Hoy le doy a mi cuerpo una palabra.",
      "Sin juicio. Solo descripcion.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde se siente en mi cuerpo? (vientre / pecho / garganta)",
      "Que intenta hacer mi cuerpo por mi?",
      "Que pequeño ablandar puedo darle?"
    ],
      [
      "Donde se siente en mi cuerpo? (vientre / pecho / garganta)",
      "Que intenta hacer mi cuerpo por mi?",
      "Que pequeño ablandar puedo darle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo no esta contra mi. Intenta proteger."
    ],
      [
      "Mi cuerpo no esta contra mi. Intenta proteger."
    ]
    ),
    action: localizedGenderNode(
      "mano en mi pecho por diez segundos.",
      "mano en mi pecho por diez segundos."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La historia en mi cabeza",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que pasa de lo que me cuento.",
      "Veo la historia.",
      "Una respiracion."
    ],
      [
      "Hoy separo lo que pasa de lo que me cuento.",
      "Veo la historia.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que historia me cuento sobre hablar frente a otros?",
      "Que significado le doy al silencio o a una mirada?",
      "Que posibilidad más suave existe?"
    ],
      [
      "Que historia me cuento sobre hablar frente a otros?",
      "Que significado le doy al silencio o a una mirada?",
      "Que posibilidad más suave existe?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no es un hecho."
    ],
      [
      "Una historia no es un hecho."
    ]
    ),
    action: localizedGenderNode(
      "me digo \"esto es una historia, no una certeza\".",
      "me digo \"esto es una historia, no una certeza\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Disparadores",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que dispara la verguenza.",
      "Es conocimiento, no culpa.",
      "Una respiracion."
    ],
      [
      "Hoy noto lo que dispara la verguenza.",
      "Es conocimiento, no culpa.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que tipo de sala, persona o mirada me activa?",
      "Que lo hace más fuerte?",
      "Que lo suaviza aunque sea un poco?"
    ],
      [
      "Que tipo de sala, persona o mirada me activa?",
      "Que lo hace más fuerte?",
      "Que lo suaviza aunque sea un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando conozco un disparador, me sorprende menos."
    ],
      [
      "Cuando conozco un disparador, me sorprende menos."
    ]
    ),
    action: localizedGenderNode(
      "elijo un disparador y lo miro sin huir.",
      "elijo un disparador y lo miro sin huir."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Mi patron",
    opening: localizedGenderNode(
      [
      "Hoy miro mi patron antes de hablar.",
      "Sin critica.",
      "Una respiracion."
    ],
      [
      "Hoy miro mi patron antes de hablar.",
      "Sin critica.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que hago para protegerme en un encuentro?",
      "Cual es el costo de esa proteccion?",
      "Que podria ser un poco diferente?"
    ],
      [
      "Que hago para protegerme en un encuentro?",
      "Cual es el costo de esa proteccion?",
      "Que podria ser un poco diferente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un cambio pequeño basta para aflojar un bucle."
    ],
      [
      "Un cambio pequeño basta para aflojar un bucle."
    ]
    ),
    action: localizedGenderNode(
      "me permito un cambio pequeño una vez.",
      "me permito un cambio pequeño una vez."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Miedo al juicio",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo debajo de la verguenza.",
      "Me quedo con el un momento.",
      "Una respiracion."
    ],
      [
      "Hoy toco el miedo debajo de la verguenza.",
      "Me quedo con el un momento.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que temo que piensen de mi?",
      "Que frase interna aparece en mi?",
      "Que me ayudaria a sentirme un poco más seguro/a?"
    ],
      [
      "Que temo que piensen de mi?",
      "Que frase interna aparece en mi?",
      "Que me ayudaria a sentirme un poco más seguro/a?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo al juicio es una necesidad de seguridad."
    ],
      [
      "El miedo al juicio es una necesidad de seguridad."
    ]
    ),
    action: localizedGenderNode(
      "noto el miedo sin pelear con el.",
      "noto el miedo sin pelear con el."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "La voz critica",
    opening: localizedGenderNode(
      [
      "Hoy noto la voz que me critica antes de hablar.",
      "Escucho sin creerle.",
      "Una respiracion."
    ],
      [
      "Hoy noto la voz que me critica antes de hablar.",
      "Escucho sin creerle.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me dice la voz critica?",
      "Que palabra usa sobre mi?",
      "Que voz suave podria responderle?"
    ],
      [
      "Que me dice la voz critica?",
      "Que palabra usa sobre mi?",
      "Que voz suave podria responderle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz critica es una voz asustada."
    ],
      [
      "Una voz critica es una voz asustada."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mi.",
      "una frase suave para mi."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Limite interno",
    opening: localizedGenderNode(
      [
      "Hoy pongo un limite interno antes de hablar.",
      "Para cuidarme.",
      "Una respiracion."
    ],
      [
      "Hoy pongo un limite interno antes de hablar.",
      "Para cuidarme.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que no es ok para mi en espacios profesionales?",
      "Como me avisa el cuerpo que es demasiado?",
      "Que limite interno puedo poner sin palabras?"
    ],
      [
      "Que no es ok para mi en espacios profesionales?",
      "Como me avisa el cuerpo que es demasiado?",
      "Que limite interno puedo poner sin palabras?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un limite interno crea espacio para respirar."
    ],
      [
      "Un limite interno crea espacio para respirar."
    ]
    ),
    action: localizedGenderNode(
      "me recuerdo ese limite antes de una reunion.",
      "me recuerdo ese limite antes de una reunion."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Lo que necesito",
    opening: localizedGenderNode(
      [
      "Hoy busco la necesidad debajo de la verguenza.",
      "No una solucion, solo una necesidad.",
      "Una respiracion."
    ],
      [
      "Hoy busco la necesidad debajo de la verguenza.",
      "No una solucion, solo una necesidad.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito para sentirme más seguro/a antes de hablar?",
      "Que me ayuda a sentirme estable?",
      "Que cosa pequeña puedo darme?"
    ],
      [
      "Que necesito para sentirme más seguro/a antes de hablar?",
      "Que me ayuda a sentirme estable?",
      "Que cosa pequeña puedo darme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando veo una necesidad, algo se calma."
    ],
      [
      "Cuando veo una necesidad, algo se calma."
    ]
    ),
    action: localizedGenderNode(
      "me doy una cosa pequeña antes de una reunion.",
      "me doy una cosa pequeña antes de una reunion."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un pequeño pedido",
    opening: localizedGenderNode(
      [
      "Hoy formulo un pequeño pedido hacia mi.",
      "Sin presion.",
      "Una respiracion."
    ],
      [
      "Hoy formulo un pequeño pedido hacia mi.",
      "Sin presion.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pequeño pedido puedo hacerme hoy?",
      "Como suena si lo digo con suavidad?",
      "Que me ayudara a recordarlo en el momento?"
    ],
      [
      "Que pequeño pedido puedo hacerme hoy?",
      "Como suena si lo digo con suavidad?",
      "Que me ayudara a recordarlo en el momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pedido suave es más amable que una orden."
    ],
      [
      "Un pedido suave es más amable que una orden."
    ]
    ),
    action: localizedGenderNode(
      "repito el pedido una vez.",
      "repito el pedido una vez."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Presencia antes de hablar",
    opening: localizedGenderNode(
      [
      "Hoy practico presencia justo antes de hablar.",
      "Eso es suficiente por hoy.",
      "Una respiracion."
    ],
      [
      "Hoy practico presencia justo antes de hablar.",
      "Eso es suficiente por hoy.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me ayuda a recordar que no estoy solo/a por dentro?",
      "Que pequeño ancla puedo llevar conmigo?",
      "Que quiero recordar cuando hablo?"
    ],
      [
      "Que me ayuda a recordar que no estoy solo/a por dentro?",
      "Que pequeño ancla puedo llevar conmigo?",
      "Que quiero recordar cuando hablo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La presencia es un escudo suave."
    ],
      [
      "La presencia es un escudo suave."
    ]
    ),
    action: localizedGenderNode(
      "un ancla conmigo (una palabra / una respiracion / un toque).",
      "un ancla conmigo (una palabra / una respiracion / un toque)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un pequeño paso",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño paso de hablar.",
      "No una revolucion.",
      "Una respiracion."
    ],
      [
      "Hoy elijo un pequeño paso de hablar.",
      "No una revolucion.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pequeño paso me queda bien?",
      "Como sabre que fue suficiente aunque sea pequeño?",
      "Que me pido a mi despues de eso?"
    ],
      [
      "Que pequeño paso me queda bien?",
      "Como sabre que fue suficiente aunque sea pequeño?",
      "Que me pido a mi despues de eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Los pasos pequenos construyen confianza."
    ],
      [
      "Los pasos pequenos construyen confianza."
    ]
    ),
    action: localizedGenderNode(
      "un paso pequeño, y eso es suficiente.",
      "un paso pequeño, y eso es suficiente."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy termino con una frase de regreso para momentos dificiles.",
      "Me quedo conmigo.",
      "Una respiracion."
    ],
      [
      "Hoy termino con una frase de regreso para momentos dificiles.",
      "Me quedo conmigo.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi sobre esta verguenza?",
      "Que me ayuda más justo antes de hablar?",
      "Mi frase corta de regreso es:"
    ],
      [
      "Que aprendi sobre esta verguenza?",
      "Que me ayuda más justo antes de hablar?",
      "Mi frase corta de regreso es:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo quedarme presente un momento antes de reaccionar."
    ],
      [
      "Puedo quedarme presente un momento antes de reaccionar."
    ]
    ),
    action: localizedGenderNode(
      "digo mi frase de regreso una vez.",
      "digo mi frase de regreso una vez."
    ),
  },
].map(buildNormalizedDay);

export const shameSpeakingAudienceWorkMeetingsBlueprintEs = buildNormalizedPilotBlueprint({
  id: "shame_speaking_audience_work_meetings_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "shame_speaking_audience_work_meetings",
  category: "anxiety",
  journeyName: {
    he: "בושה לדבר מול קהל / ישיבות עבודה",
    en: "Shame speaking in front of an audience / work meetings",
    es: "Verguenza al hablar frente a un grupo / reuniones de trabajo",
  },
  days,
});

export default shameSpeakingAudienceWorkMeetingsBlueprintEs;
